export const SOCIAL_IMAGE_VERSION = 'v2';
export const SOCIAL_IMAGE_COPY = {
  en: ['Create music with AI, for free', 'Listen to the song', 'Your next favorite song.', 'Made with MusicMint'],
  zh: ['AI 免费创作音乐', '听听这首歌', '把灵感，\n变成你的歌。', '使用 MusicMint 创作'],
  'zh-TW': ['AI 免費創作音樂', '聽聽這首歌', '把靈感，\n變成你的歌。', '使用 MusicMint 創作'],
  ja: ['AIで音楽を無料作成', 'この曲を聴く', 'ひらめきを、あなたの曲に。', 'MusicMintで作成'],
  ko: ['AI로 무료 음악 만들기', '노래 듣기', '영감을 나만의 노래로.', 'MusicMint로 제작'],
  de: ['Mit KI kostenlos Musik machen', 'Song anhören', 'Dein nächster Lieblingssong.', 'Mit MusicMint erstellt'],
  es: ['Crea música gratis con IA', 'Escucha la canción', 'Tu próxima canción favorita.', 'Creada con MusicMint'],
  fr: ['Créez de la musique gratuitement avec l’IA', 'Écouter le morceau', 'Votre prochain coup de cœur.', 'Créé avec MusicMint'],
};
export const socialImageLocale = value => typeof value === 'string' && Object.hasOwn(SOCIAL_IMAGE_COPY, value) ? value : 'en';
// Brand fallbacks remain the existing immutable assets.
export const brandSocialImagePath = locale => `/images/social/brand-${socialImageLocale(locale)}-v1.png`;
export function songSocialImagePath(token, locale) {
  return `/__social/song/${encodeURIComponent(token)}.png?lang=${socialImageLocale(locale)}&v=${SOCIAL_IMAGE_VERSION}`;
}

// Only completed assets from our existing CDN namespace may enter public metadata.
export function readySocialImage(payload, locale, version = SOCIAL_IMAGE_VERSION) {
  if (!['v1', SOCIAL_IMAGE_VERSION].includes(version) || payload?.social_image_version !== version) return null;
  const value = payload?.social_images?.[socialImageLocale(locale)];
  if (typeof value !== 'string') return null;
  try {
    const url = new URL(value);
    if (url.protocol !== 'https:' || !['musics3.styletpff.com', 's3.styletpff.com'].includes(url.hostname) || url.port || url.username || url.password || url.search || url.hash || !new RegExp(`^/test/social-preview/${version}/[a-f0-9]{64}/[a-f0-9]{64}\\.png$`).test(url.pathname)) return null;
    return url.href;
  } catch { return null; }
}
